import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postServices({ body }) {
  return BaseService.post(REST.SERVICES_REQUESTS, body);
}

function putServices({ body, id }) {
  return BaseService.put(REST.SERVICES_REQUESTS_ID(id), body);
}

function getServices(params) {
  return BaseService.get(REST.SERVICES_REQUESTS, {
    params: paramsFilter({ params }),
  });
}

function deleteServices({ id }) {
  return BaseService.delete(REST.SERVICES_REQUESTS_ID(id));
}

export default {
  postServices,
  putServices,
  getServices,
  deleteServices,
};
